import React from 'react'
import './Why.css'
import whyimg1 from './why-img/woman-charging-her-electric-car-with-charging-pistol (2).jpg'
import whyimg2 from './why-img/Firefly 20250108123955.png'
import whyimg3 from './why-img/woman-charging-electro-car-electric-gas-station.jpg'
import Marquee from 'react-fast-marquee'
import benz from './why-img/slider-imggg/benz.png'
import bmw from './why-img/slider-imggg/bmw.png'
import mg from './why-img/slider-imggg/mg.png'
import tata from './why-img/slider-imggg/tata.png'
import ather from './why-img/slider-imggg/ather.png'
import mahindra from './why-img/slider-imggg/mahindra.png'
import jaguar from './why-img/slider-imggg/jaguar.png'
import citron from './why-img/slider-imggg/citroen.png'
import mini from './why-img/slider-imggg/mini.png'
import porsche from './why-img/slider-imggg/porsche.png'
import rr from './why-img/slider-imggg/rr.png'
import volvo from './why-img/slider-imggg/volvo.png'
import hyundai from './why-img/slider-imggg/hyundai.png'
import kia from './why-img/slider-imggg/kia.png'
import ola from './why-img/slider-imggg/ola.png'
import tvs from './why-img/slider-imggg/tvs.png'
import bajaj from './why-img/slider-imggg/bajaj.png'
import byd from './why-img/slider-imggg/byd.png'
import em from './why-img/slider-imggg/em.png'
import lotus from './why-img/slider-imggg/lotus.png'
import oben from './why-img/slider-imggg/oben.png'
import piaggio from './why-img/slider-imggg/piaggio.png'
import motovolt from './why-img/slider-imggg/motovolt.png'

const Why = () => {
    return (
        <div className='why-main'>
            <div className="why-content">
                <div className="content">
                    <div className="why-head" data-aos="fade-up">
                        <div className="whychoose-head">
                            <p >Why Choose Us </p>
                            <div className="why-line"></div>
                        </div>
                    </div>
                    <div className="why-content-head" data-aos="fade-up">
                        <p>The Biggest EV Charging Station</p>
                    </div>
                    <img src={whyimg1} alt="" className='why-img1' data-aos="fade-up" />
                </div>
                <div className="content">
                    <img src={whyimg2} alt="" className='why-img2' data-aos="fade-up" />
                </div>
                <div className="content">
                    <img src={whyimg3} alt="" className='why-img3' data-aos="fade-up" />
                    <p className='content3-p' data-aos="fade-up"> AIZO Plug stand out with over 9 years of expertise in manufacturing reliable EV
                        charging solutions. We specialize in delivering high-quality, customized charging
                        stations designed to meet India’s unique needs, ensuring efficient performance and
                        long-term sustainability.</p>
                    {/* <button data-aos="fade-up">Learn More</button> */}
                </div>
            </div>
            <div className="scrolling-main">
                <div className="why-scrolling">
                    <div className="scrolling">
                        <Marquee>
                            <img src={benz} alt="" />
                            <img src={bmw} alt="" />
                            <img src={mg} alt="" />
                            <img src={tata} alt="" />
                            <img src={ather} alt="" />
                            <img src={mahindra} alt="" />
                            <img src={jaguar} alt="" />
                            <img src={citron} alt="" />
                            <img src={mini} alt="" />
                            <img src={porsche} alt="" />
                            <img src={rr} alt="" />
                            <img src={ola} alt="" />
                            <img src={volvo} alt="" />
                            <img src={hyundai} alt="" />
                            <img src={kia} alt="" />
                            <img src={tvs} alt="" />
                            <img src={bajaj} alt="" />
                            <img src={byd} alt="" />
                            <img src={em} alt="" />
                            <img src={lotus} alt="" />
                            <img src={oben} alt="" />
                            <img src={piaggio} alt="" />
                            <img src={motovolt} alt="" />
                        </Marquee>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Why